import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../assets/logo_play.svg';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-auto py-8 bg-[#13111d] text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center">
            <img 
              src={logo} 
              alt="OXO Play" 
              className="h-8 transition-all duration-300 ease-in-out transform hover:rotate-6"
            />
          </div>
          <div className="flex flex-wrap items-center justify-center space-x-4">
            <Link to="/about" className="hover:text-purple-400">
              {t('common.about_us')}
            </Link>
            <Link to="/contact" className="hover:text-purple-400">
              {t('common.contact_us')}
            </Link>
            <Link 
              to="/privacy" 
              className="hover:text-purple-400"
            >
              {t('common.privacy_policy')}
            </Link>
            <div className="ml-4">
              <LanguageSwitcher />
            </div>
          </div>
        </div>
        <div className="mt-4 text-center md:text-left text-gray-400 text-sm">
          {t('common.copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
} 